import { render } from "./good-road-timer-icon.vue?vue&type=template&id=38a24418&ts=true"
import script from "./good-road-timer-icon.vue?vue&type=script&lang=ts"
export * from "./good-road-timer-icon.vue?vue&type=script&lang=ts"

import "./good-road-timer-icon.vue?vue&type=style&index=0&id=38a24418&lang=scss"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__